(function() {
  const COOKIE_NAME = 'optOut'

  // REFERENCE SNIPPET
  // const acceptedHTML = `
  //   <!-- Global site tag (gtag.js) - Google Analytics -->
  //   <script src="https://www.googletagmanager.com/gtag/js?id=G-X47PWTLT80"></script>
  //   <script>
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());

  //     gtag('config', 'G-X47PWTLT80');
  //   </script>
  // `

  const addAcceptedHTML = function () {
    // script cannot be inserted using innerHTML, must be created and
    // appended.
    // See https://www.w3.org/TR/2008/WD-html5-20080610/dom.html#innerhtml0
    const gtag = document.createElement('script')
    gtag.async = true
    gtag.src = `https://www.googletagmanager.com/gtag/js?id=${window._futuress.gaId}`

    const gtagStart = document.createElement('script')
    const js = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', window._futuress.gaId);
    `)

    gtagStart.appendChild(js)
    document.body.appendChild(gtag)
    document.body.appendChild(gtagStart)
  }

  const getCookie = function () {
    const v = document.cookie.match('(^|;) ?' + COOKIE_NAME + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }

  const setCookie = function(optsOut) {
    // Build the expiration date string:
    const expirationDate = new Date()
    let cookieString = ''
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    // Build the set-cookie string:
    cookieString = `${COOKIE_NAME}=${!!optsOut}; path=/; expires=${expirationDate.toUTCString()}`
    // Create or update the cookie:
    document.cookie = cookieString
  }

  const closeBanner = function() {
    const banner = document.querySelector('.cookie-banner')
    banner.classList.add('cookie-banner--closed')
  }

  const rejectAll = function(event) {
    setCookie(true)
    closeBanner()
    console.log('reject all')
  }

  const acceptAll = function() {
    addAcceptedHTML()
    setCookie(false)
    closeBanner()
    console.log('allow all')
  }

  const checkCurrentSettings = function() {
    const cookieValue = getCookie()
    const optOut = cookieValue === 'true'

    // if there is no previous decision, show the banner
    if (!cookieValue) {
      const banner = document.querySelector('.cookie-banner')
      banner.classList.remove('cookie-banner--idle')
      return
    }

    // if we haven't opted out, add the tracking html
    if (!optOut) {
      addAcceptedHTML()
    }
  }

  const onLoad = function() {
    const closeBanner = document.querySelector('.cookie-banner-close')
    const rejectAllButton = document.querySelector('.reject-all')
    const allowAllButton = document.querySelector('.allow-all')

    closeBanner.addEventListener('click', rejectAll)
    rejectAllButton.addEventListener('click', rejectAll)
    allowAllButton.addEventListener('click', acceptAll)

    checkCurrentSettings()
  }

  document.addEventListener('DOMContentLoaded', onLoad)
}())